import reactComponentLoader from 'scripts/react-component-loader'

import { Routes } from './routes'

reactComponentLoader(Routes, '[data-page]')
